import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`;

export const SourceOption = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  border: 2px solid ${(props) => 
    props.$isActive 
      ? props.theme.colors?.primary || "#3B82F6"
      : props.theme.colors?.border || "#E5E7EB"
  };
  border-radius: 12px;
  background: ${(props) => 
    props.$isActive 
      ? props.theme.colors?.primaryLight || "#EFF6FF"
      : props.theme.colors?.background || "#FFFFFF"
  };
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
    background: ${(props) => props.theme.colors?.primaryLight || "#EFF6FF"};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${(props) => props.theme.colors?.primaryLight || "#EFF6FF"};
  }
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  border-radius: 12px;
  background: ${(props) => 
    props.$isActive 
      ? props.theme.colors?.primary || "#3B82F6"
      : props.theme.colors?.backgroundSecondary || "#F3F4F6"
  };
  color: ${(props) => 
    props.$isActive 
      ? "#FFFFFF"
      : props.theme.colors?.textSecondary || "#6B7280"
  };

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const OptionTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.text || "#111827"};
  margin-bottom: 4px;
`;

export const OptionDescription = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
  text-align: center;
`;
